import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { unregister } from './registerServiceWorker';
import { version as currentVersion } from './version';

import { Provider } from 'react-redux';
import store from './store';
import Auth from "./services/auth";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);

unregister();
// logger
function getCircularReplacer() {
  const ancestors = [];
  return function(key, value) {
    if (typeof value !== "object" || value === null) return value;
    if (value instanceof Error) return { name: value.name, message: value.message };
    while (ancestors.length > 0 && ancestors.at(-1) !== this) ancestors.pop();
    if (ancestors.includes(value)) return "[Circular]";
    if (ancestors.length === 5) return "[...]";
    ancestors.push(value);
    return value;
  };
}
const logToServer = (e, errorCount = 0) => {
  const auth = Auth.getInstance();
  if (!auth.isAuthenticated()) return setTimeout(() => logToServer(e), 5000);
  fetch(
    '/api/v1/ui/log',
    {
      method: 'POST',
      body: JSON.stringify(e, getCircularReplacer()),
      headers: {
        authorization: 'Bearer ' + auth.getAccessToken(),
        'content-type': 'application/json'
      }
    }
  ).then(res => { if (res.status >= 400) throw new Error('log request failed'); })
    .catch(() => errorCount < 5 && setTimeout(() => logToServer(e, errorCount++), 5000));
};
const consoleError = window.console.error;
window.console.error = (...args) => {
  consoleError.apply(null, args);
  const level = 'error';
  const url = window.location.href;
  const timestamp = Date.now();
  const agent = navigator.userAgent;
  logToServer({ level, args, url, timestamp, agent });
};
const consoleLog = window.console.log;
window.console.log = (...args) => {
  consoleLog.apply(null, args);
  const level = 'info';
  const url = window.location.href;
  const timestamp = Date.now();
  const agent = navigator.userAgent;
  logToServer({ level, args, url, timestamp, agent });
};
window.onerror = console.error.bind(console, 'onerror');
window.addEventListener('error', console.error.bind(console, 'error'));
window.addEventListener('unhandledrejection', e => console.error(e.type, e.reason));
// cache buster
const checkForUpdate = () => {
  fetch(process.env.PUBLIC_URL + '/meta.json?t=' + Date.now())
    .then(response => response.json())
    .then(meta => {
      const latestVersion = meta.version;
      if (latestVersion !== currentVersion) {
        store.dispatch({ type: 'NEW_APP_CONTENT_AVAILABLE' });
      }
    })
    .catch(consoleError);
};
window.addEventListener('load', checkForUpdate);
window.setInterval(checkForUpdate, 60000);



// WEBPACK FOOTER //
// ./src/index.js